import { NgModule, APP_INITIALIZER } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BarcodeScanner } from '@awesome-cordova-plugins/barcode-scanner/ngx';
import { SharedComponentsModule } from './common/sharedComponents/shared-components.module';
import { ErrorInterceptorService } from './common/sharedServices/httpInterceptors/error/error-interceptor.service';
import { LoginPage } from './login/login.page';
import { SqlAdapterService } from './common/sharedServices/sql/sql-adapter.service';
import { PlatformInterceptorService } from './common/sharedServices/httpInterceptors/platform/platform-interceptor.service';
import { VersionInterceptorService } from './common/sharedServices/httpInterceptors/version/version-interceptor.service';
import { AngularSignaturePadModule } from '@almothafar/angular-signature-pad';
import { AuthInterceptorService } from './common/sharedServices/httpInterceptors/auth/auth-interceptor.service';
import { Storage } from '@ionic/storage';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

export function initializeApp(sqliteService: SqlAdapterService, storage: Storage) {
  return async () => {
    await storage.create();
    await sqliteService.initializePlugin();
  };
}

@NgModule({ declarations: [
        AppComponent,
        LoginPage
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        IonicModule.forRoot({
            mode: 'md'
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: (createTranslateLoader),
                deps: [HttpClient]
            }
        }),
        SharedComponentsModule,
        AngularSignaturePadModule,
        AppRoutingModule], providers: [
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: PlatformInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: VersionInterceptorService, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptorService, multi: true },
        BarcodeScanner,
        Storage, // Aggiungi questa riga
        {
            provide: APP_INITIALIZER,
            useFactory: initializeApp,
            deps: [SqlAdapterService, Storage],
            multi: true
        },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule { }
